var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',[_c('b-card',[_c('h3',[_vm._v("Not found!")]),_c('b-button',{staticClass:"btn-round",attrs:{"to":"home","variant":"primary"}},[_c('i',{staticClass:"bi-caret-left"}),_vm._v(" Back ")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }